import OGlobalSidebar from './index.vue';

OGlobalSidebar.install = app => {
  app.component(OGlobalSidebar.name, OGlobalSidebar);
};

export default OGlobalSidebar;
